import React from 'react';
import { AnimateOnScroll } from '../AnimateOnScroll';
export function DVWhatIs() {
  return <section className="bg-[#ECECEC] py-[60px] lg:py-[100px]" data-id="element-1058">
      <div className="max-w-[800px] mx-auto px-6 lg:px-8" data-id="element-1059">
        <AnimateOnScroll className="text-center flex flex-col items-center" data-id="element-1060">
          <h2 className="text-[26px] lg:text-[40px] uppercase text-black leading-tight mb-6 font-[600] font-[Poppins,_sans-serif]" data-id="element-1061">
            WHAT IS VAGINAL REJUVENATION?
          </h2>

          <div className="w-[40px] h-[2px] bg-[#FF1493] mb-8" data-id="element-1062"></div>

          <p className="text-[#333333] text-[17px] leading-[1.8] font-body mb-12" data-id="element-1063">
            When it comes to vaginal rejuvenation, Be CLINICAL wants women to be
            comfortable in their desires for a happy, healthy sex life.
          </p>

          <div className="relative max-w-[700px] mx-auto mb-12" data-id="element-1064">
            <div className="text-[#FF1493] text-[60px] font-serif leading-none select-none opacity-60 mb-2" data-id="element-1065">
              &ldquo;
            </div>
            <p className="font-serif italic text-black text-lg lg:text-[22px] leading-[1.6]" data-id="element-1066">
              Ladies, come on! You know your sexual health is so important and a
              massive (fun) part of life!
            </p>
          </div>

          <div className="space-y-6 text-[#333333] text-[17px] leading-[1.8] font-body" data-id="element-1067">
            <p data-id="element-1068">
              Laser vaginal rejuvenation can address concerns like vaginal
              laxity, urinary incontinence, vaginal dryness, discomfort during
              intercourse and aesthetic preferences. These treatments aim to
              restore or enhance the vaginal area's appearance, function and
              overall comfort.
            </p>
            <p data-id="element-1069">
              Come in and speak to us about this wonderful laser treatment that
              is quick, easy, painless and will help you turn back time and
              start enjoying yourself again!
            </p>
          </div>
        </AnimateOnScroll>
      </div>
    </section>;
}